export {default as path} from "./path";



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-path/src/index.js
// module id = 142
// module chunks = 0